import { fadeOut , fadeIn } from "../modules/_general_methods.js";

export const forceDeleteLoader = () => {
  let loader = document.getElementById("loader");
  setTimeout(function(){
    fadeOut( loader , 500);
  },500);
}